import { RouteObject } from 'react-router-dom';
import {
  ErrorBoundary,
  GroupRoute,
  ParticipantsTable,
  StudiesList,
  StudiesResearchersTable,
} from 'src/components';
import { UserGroup } from 'src/types/users';
import { MainRouteV2 } from '../main-routev2';
import { StudiesCreatePage } from './studies-create-page';
import { StudiesDetailsPage } from './studies-details-page';
import { StudiesPage } from './studies-page';

export const studiesRouter: RouteObject[] = [
  {
    path: 'studies',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<MainRouteV2 component={<StudiesPage />} title="studies_header" />}
      />
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<StudiesList />}
          />
        ),
        errorElement: <ErrorBoundary />,
        children: [
          {
            path: 'create',
            element: (
              <GroupRoute groupsPermitted={[UserGroup.ADMIN]} component={<StudiesCreatePage />} />
            ),
            errorElement: <ErrorBoundary />,
          },
        ],
      },
    ],
  },
  {
    path: 'studies/:studyId',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<StudiesDetailsPage />}
      />
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: 'participants',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<ParticipantsTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'researchers',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<StudiesResearchersTable />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
    ],
  },
];
